import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from './../../services/http.service';
import { TagMasterService } from './../../services/tagmaster-service';
import { GlobalService } from './../../services/global.service';
import { PiHistoryService } from './../../services/pihistory-service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertComponent } from '../../common/alert/alert.component';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-run-pihistory-data',
  templateUrl: './run-pihistory-data.component.html',
  styleUrls: ['./run-pihistory-data.component.css']
})
export class RunPIHistoryDataComponent implements OnInit {

  unitList;
  tagList = [];
  selectedTagIds = [];
  dropdownSettings = {};
  tagIds: any = [];
  startDate = new Date();
  endDate = new Date();
  runBy;
  lenErr: boolean = false;
  error: boolean = false;
  unitFlag: boolean = false;
  datDiffErrMsg: string = '';
  tagCounter = 0;
  useCaseList;
  selectedUseCase;
  selectedUSeCaseId;
  selectedUnit;
  checkedADL: boolean = true;
  useCaseFlag: boolean = false;
  tagsFlag: boolean = false;
  isLoader: boolean = false;
  allChecked: boolean = false;
  @ViewChild('runForm', { static: true }) public runForm: NgForm;
  @Input() max: Date | null
  today = new Date();
  locationList: any = [];
  selectedLocationName: any;

  constructor(
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<RunPIHistoryDataComponent>,
    private readonly httpService: HttpService,
    private readonly tagMasterService: TagMasterService,
    public globalService: GlobalService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly piHistoryService: PiHistoryService,

  ) { }

  ngOnInit() {
    this.today.setDate(this.today.getDate());
    this.getLocationList();
    this.getUseCaseList();

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'tagId',
      textField: 'tagId',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 10,
      limitSelection: 100,
      allowSearchFilter: true
    };
  }

  getUseCaseList() {
    this.tagMasterService.getUseCases().subscribe(useCaseData => {
      this.useCaseList = useCaseData;
    });
  }

  getLocationList() {
    this.tagMasterService.getLocations().subscribe(data => {
      this.locationList = data;
      this.selectedLocationName = data[0].locationName;
      this.getUnitList();
    }, (error) => {
      console.log(error);
    });
  }

  onSelectLocation() {
    this.getUnitList();
  }

  getUnitList() {
    let locationId = this.locationList.find(l => l.locationName == this.selectedLocationName).locationId;
    this.tagMasterService.getUnits(locationId).subscribe(unitData => {
      this.unitList = unitData;
    }, (error) => {
      console.log(error);
    });
  }

  unitKeyUp(selection) {
    let unitId;
    if (selection.value == "") {
      this.unitFlag = true;
      this.selectedUnit = undefined;
    } else {
      let isUnitAvailable = this.unitList.filter(function (obj) {
        if (obj.unitName == selection.value) {
          unitId = obj.unitId;
        }
        return obj.unitName == selection.value;
      });
      if (isUnitAvailable.length == 0) {
        this.unitFlag = true;
        this.tagList = [];
      } else {
        this.unitFlag = false;
      }
      this.selectedUnit = unitId;
    }

  }

  getTagList() {
    this.tagCounter = 0;
    this.lenErr = false;
    this.allChecked = false;
    this.selectedTagIds = [];
    let locationId = this.locationList.find(l => l.locationName == this.selectedLocationName).locationId;
    if (this.selectedUnit != "") {
      this.isLoader = true;

      this.tagMasterService.getTagIds(locationId, this.selectedUnit, '', this.selectedUSeCaseId).subscribe((tagList: any): void => {
        this.isLoader = false;
        if (tagList.length > 0) {
          this.tagsFlag = false;
          this.tagList = tagList;
        } else {
          this.tagsFlag = true;
          this.tagList = tagList;
        }
      });
    } else {
      this.tagList = [];
    }
  }

  checkUncheckAll() {
    if (this.allChecked === true) {
      this.allChecked = false;
      for (let i = 0; i < this.tagList.length; i++) {
        this.chkTagIds(this.tagList[i].tagId);
      }
    } else {
      this.allChecked = true;
      for (let i = 0; i < this.tagList.length; i++) {
        this.chkTagIds(this.tagList[i].tagId);
      }
    }
  }
  convert(str) {
    let date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  saveRun(runForm: NgForm) {
    this.runBy = this.globalService.loggedInUser;
    let useCases = new Array(this.selectedUseCase);
    let values = {
      "RunBy": this.runBy,
      "Parameters": {
        "StartDate": runForm.value.startDate,
        "EndDate": runForm.value.endDate,
        "TagIds": this.selectedTagIds,
        "onlyADL": this.checkedADL,
        "useCase": useCases,
        "Location": this.selectedLocationName
      }
    }

    this.piHistoryService.addRun(values).subscribe((result: any): void => {
      if (String(result.value).startsWith("Success")) {
        this.globalService.showAlert(AlertComponent, { success: true, message: (String(result.value).replace(":", ". Run Id: ")) });
        this.dialogRef.close("Success");
      } else {
        this.error = true;
      }
    }, (error: HttpErrorResponse) => {
      if (error.error.toLowerCase().indexOf('pipeline execution throttled') > -1) {
        this.globalService.showAlert(AlertComponent, { success: false, message: 'PI History Request Queue limit (100) has reached. Please try again later.' });
      }
      else {
        this.globalService.showAlert(AlertComponent, { success: false, message: 'Something went wrong while requesting History data. Please try again later.' });
      }
    });
  }

  resetRun() {
    this.runForm.reset();
    this.tagCounter = 0;
    this.selectedUnit = undefined;
    this.selectedUSeCaseId = undefined;
  }

  onDate(event) {
    if (this.startDate > this.endDate) {
      this.datDiffErrMsg = "Start date cannot be greater than end date";
    }
    else {
      let diff = Math.abs(this.endDate.getTime() - this.startDate.getTime());
      let diffDays = Math.ceil(diff / (1000 * 3600 * 24));
      if (diffDays > 365) {
        this.datDiffErrMsg = "Date difference should be within 1 year.";
      }
      else {
        this.datDiffErrMsg = "";
      }
    }
  }
  chkTagCounter(){
    if (this.tagCounter < 101) {
      this.lenErr = true;
    } else {
      this.lenErr = false;
    }
    if (this.tagCounter == 0) {
      this.allChecked = true;
    }
  }

  chkTagCounterGreaterValue(){
    if (this.tagCounter > 0 && this.tagCounter < 101) {
      this.lenErr = true;
    } else {
      this.lenErr = false;
    }
    if (this.tagCounter == 0) {
      this.allChecked = false;
    }
  }
  
  chkTagIds(event) {
    if (!this.selectedTagIds.includes(event)) {
      this.tagCounter = this.tagCounter + 1;
      this.selectedTagIds.push(event);
      this.chkTagCounter();
    } else {
      let position = this.selectedTagIds.indexOf(event);
      this.selectedTagIds.splice(position, 1);
      this.tagCounter = this.tagCounter - 1;
     this.chkTagCounterGreaterValue();
    }
    if (this.tagList.length > 100 && this.tagCounter == this.tagList.length) {
      this.globalService.showAlert(AlertComponent, { success: true, message: "Only 100 tags allowed for selection to run Pi History pipeline." });
    }
    if (this.tagList.length > 100 && this.tagCounter == 100) {
      this.globalService.showAlert(AlertComponent, { success: true, message: "You have reached tagId selection limit 100 to Run Pi History pipeline." });
    }

  }

  chkTillADL(event) {
    if (event.target.value == "Use Case Database") {
      this.checkedADL = false;
      this.useCaseFlag = false;
    } else {
      this.checkedADL = true;
    }

  }

  useCaseKeyUp(useCase) {
    if (this.checkedADL === false && useCase.value == '') {
      this.useCaseFlag = true;
      this.selectedUSeCaseId = undefined;
    } else {
      this.useCaseFlag = false;
      this.selectedUSeCaseId = undefined;
    }
    if (useCase.value != '') {
      this.selectedUseCase = useCase.value;
      let checked = this.useCaseList.filter(function (obj) {
        return obj.useCaseName == useCase.value;
      });

      if (checked.length == 0) {
        this.useCaseFlag = true;
        this.selectedUSeCaseId = undefined;
      } else {
        this.selectedUSeCaseId = checked[0].useCaseId;
        this.useCaseFlag = false;
      }
    }
  }

  onCancelClick(): void {
    this.dialogRef.close("Cancel");
  }
}
